var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sac-toggle-switch-container"},[_c('label',{staticClass:"sac-toggle-switch"},[_c('input',{staticClass:"sac-toggle-checkbox",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',{staticClass:"sac-toggle-slider round"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }